<template>
  <Transition
    :enter-active-class="`transition-all ${durationClasses} ease-linear`"
    :leave-active-class="`transition-all ${durationClasses} ease-linear`"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
    mode="out-in"
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { TransitionDuration } from '~/modules/ui/types'

const { duration = 200 } = defineProps<{ duration?: TransitionDuration }>()

const durationClasses = computed(() => {
  switch (duration) {
    case 75:
      return 'duration-75'
    case 100:
      return 'duration-100'
    case 150:
      return 'duration-150'
    case 200:
      return 'duration-200'
    case 300:
      return 'duration-300'
    case 500:
      return 'duration-500'
    case 700:
      return 'duration-700'
    case 1000:
      return 'duration-1000'
    default:
      return 'duration-0'
  }
})
</script>
